<template>
  <div class="jlzd-dialog-wrap">
    <CvipDialog @btnClick="vipBuy()" @close="close()" :title="title1" :btnTxt="btnTxt1"  v-if="(cvipMes.cvipstate===1 || cvipMes.cvipstate===10) && rightUsed[5]">
      <p class="tit">恭喜您，已获得<span  class="tit-names">简历置顶</span>特权</p>
      <p class="des"><span class="des-in des-use">特权介绍：使用置顶后您的全职简历将在列表顶端展示，更多HR将会看到您的简历。功能有天数限制，基础版增送4天，升级版增送8天</span></p>
      <div class="jlzd-bg"><img class="jlzd-bg-img" src="../../../../assets/imgs/pri-jlzd.png"></div>
    </CvipDialog>
    <CvipDialog @btnClick="topResumefn()" @close="close()" :title="title1" :btnTxt="resumeListNum ? '立即体验' : '创建简历'"  v-else-if="(cvipMes.cvipstate===1 || cvipMes.cvipstate===10) && !rightUsed[5]">
      <p class="tit tit-nouse">恭喜您，已获得<span  class="tit-names">简历置顶</span>特权</p>
      <p class="des"><span class="des-in des-use">特权介绍：使用置顶后您的全职简历将在列表顶端展示，更多HR将会看到您的简历。功能有天数限制，基础版增送4天，升级版增送8天</span></p>
      <div class="jlzd-bg"><img class="jlzd-bg-img" src="../../../../assets/imgs/pri-jlzd.png"></div>
    </CvipDialog>
    <CvipDialog @btnClick="vipBuy()" @close="close()" :title="title" :btnTxt="btnTxt" v-else>
      <p class="des">特权介绍：<span class="des-in">使用置顶后您的全职简历将在列表顶端展示，更多HR将会看到您的简历。功能有天数限制，基础版增送4天，升级版增送8天</span></p>
      <div class="jlzd-bg"><img class="jlzd-bg-img" src="../../../../assets/imgs/pri-jlzd.png"></div>
    </CvipDialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CvipDialog from "./common/CvipDialog"
export default {
  name: 'jlzdDialog',
  components: {
    CvipDialog
  },
  data () {
    return {
      title: '简历置顶',
      btnTxt: '开通会员尊享特权',
      title1: '',
      btnTxt1: '',
      title2: ''
    }
  },
  created () {
    window.clickLog && window.clickLog(`from=pc-cvip-jlzd-tanchuang-show-${this.cvipMes.cvipstate}`)
  },
  methods: {
    // 点击支付按钮
    vipBuy () {
      window.clickLog && window.clickLog(`from=pc-cvip-tqtc-jlzd-ljkt-${this.cvipMes.cvipstate}`)
      this.$emit('buyDialog')
    },
    close () {
      window.clickLog && window.clickLog(`from=pc-cvip-tqtc-jlzd-close-${this.cvipMes.cvipstate}`)
      this.$emit('closeDialog')
    },
    topResumefn () {
      this.$emit('topResume')
    }
  },
  computed: mapGetters({
    cvipMes: 'cvipMes',
    rightUsed: 'rightUsed', //4：黄金亮点 5：置顶 10：尊贵标识 11：个人认证 12：求职分析 13：免费刷新 14：求职保障 15：意外保险
    resumeListNum: 'resumeListNum'
  })
}
</script>

<style lang="scss" scoped>
.tit {
  margin-top: 80px;
}
.jlzd-bg {
  width: 606px;
  height: 290px;
  margin: 20px auto 0;
  overflow: hidden;
}
.jlzd-bg-img {
  width: 606px;
  height: 290px;
}
.des-in {
  font-size: 14px;
  color: #aaa;
}
.des-use {
  width: 100%;
  display: inline-block;
  //text-align: center;
}
.tit {
  margin: 55px 0 8px;
  font-size: 24px;
  color: #333;
  line-height: 33px;
  text-align: center;
}
.tit-nouse {
  margin-top: 30px;
}
.tit-names {
  font-size: 24px;
  color: #D4B277;
  line-height: 33px;
}
</style>



// WEBPACK FOOTER //
// JlzdDialog.vue?24fab082